import { Center, Loader } from "@mantine/core";
import { FC } from "react";

import { color } from "../../constant/color";

const ContentLoader: FC = () => (
  <Center style={{ minHeight: "60vh", width: "100%" }}>
    <Loader size="lg" color={color.FHGREEN} />
  </Center>
);

export default ContentLoader;
